import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, mergeProps as _mergeProps, vShow as _vShow, withDirectives as _withDirectives, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "contentHeader flex" }
const _hoisted_2 = { class: "contentBox" }
const _hoisted_3 = { class: "block w-full" }
const _hoisted_4 = { class: "flex mb-4" }
const _hoisted_5 = ["title"]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "icon-neu" }, null, -1)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = ["title", "disabled"]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "icon-loeschen" }, null, -1)
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = ["title"]
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", { class: "icon-upload" }, null, -1)
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = ["title", "disabled"]
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", { class: "icon-downlaod" }, null, -1)
const _hoisted_16 = [
  _hoisted_15
]
const _hoisted_17 = { class: "ml-auto" }
const _hoisted_18 = { class: "text-center" }

import {useSystemStore} from "@/stores/system/SystemStore";
import {BryntumGrid} from "@bryntum/grid-vue-3";
import GridInputFilter from "@/components/system/GridInputFilter.vue";
import {ErrorLocationType, PopupType, TableType} from "@/utilities/system/enums/Enums";
import {onBeforeUnmount, onMounted, reactive, ref} from "vue";
import {Menu, Store, StringHelper} from "@bryntum/grid";
import {checkboxColumnConfig, defaultSpaceAroundTableOnPage, featureColumn} from "@/AppConfig";
import {useI18n} from "vue-i18n";
import exportFromJSON from "export-from-json";
import dialog from "@/components/system/dialog";
import FilterService from "@/utilities/system/services/FilterService";
import {PlantService} from "@/utilities/services/entities/PlantService";
import {Plant} from "@/models/entities/plants/Plant";
import Error from "@/components/system/Error.vue";
import LoadingSpinner from "@/components/system/LoadingSpinner.vue";
import {PlantCsvExport} from "@/models/helpers/CsvExportModels";



export default /*#__PURE__*/_defineComponent({
  __name: 'PlantManagment',
  setup(__props) {

const {t} = useI18n();
const systemStore = useSystemStore();
const plantService = new PlantService();

const currentWindowHeight = ref("");
const recalcGridHeight = () => {
  currentWindowHeight.value = `${window.innerHeight-defaultSpaceAroundTableOnPage}px`;
};


const selectedPlants = ref([])


const gridStore = new Store()
const grid = ref(null)
const useGridConfig = {
  headerMenuFeature: false,
  relayStoreEvents: true,
  cellTooltipFeature: {
    hoverDelay      : 300,
    textContent     : true,
    hideOnDelegateChange: true,
  },
  enableTextSelection: false,
  selectionMode : {
    row	  : true,
    checkbox: checkboxColumnConfig,
    showCheckAll : true,
    deselectFilteredOutRecords: true
  },
  columns : {
    data: [
      {
        id:'name',
        field: 'name',
        text: t('plantManagment.grid.name'),
        flex: 1,
        type: "template",
        template: ({value}:any) => {
          return StringHelper.xss`${value ?? ""}`;
        }
      },
      {
        id: 'infoButton',
        field: 'infoButton',
        text: '',
        width: 36,
        sortable: false,
        type: "template",
        template: () => {
          return `<div class='gridRowButton'><span class='icon-info'></span></div>`;
        },
      },
      {
        id:'phoneNumber',
        field: 'phoneNumber',
        text: t('plantManagment.grid.phoneNumber'),
        flex: 1,
        type: "template",
        template: ({record}:any) => {
          return `${record.dialCode ?? ""}${record.phoneNumber ?? ""}`;
        },
      },
      {
        id:'email',
        field: 'email',
        text: t('plantManagment.grid.email'),
        flex: 1,
        type: "template",
        template: ({value}:any) => {
          return StringHelper.xss`${value ?? ""}`;
        }
      },
      {
        id:'street',
        field: 'street',
        text: t('plantManagment.grid.street'),
        flex: 1,
        type: 'template',
        template: ({record, value}:any)=>{
          return StringHelper.xss`${value ?? ""} ${record.data.houseNumber ?? ""}`;
        }
      },
      {
        id:'postalcode',
        field: 'postalcode',
        text: t('plantManagment.grid.postalcode'),
        flex: 1,
        type: 'template',
        template: ({record, value}:any)=>{
          return StringHelper.xss`${value ?? ""} ${record.data.city ?? ""}`;
        }
      },
      {
        id:'menu',
        text	: '',
        width   : 36,
        type	: 'widget',
        align: "center",
        hideable: false,
        resizable: false,
        sortable: false,
        filterable: false,
        widgets : [{
          type	 : 'button',
          width: 36,
          icon	 : 'icon-kontext_horizontal',
          onAction : ({ source: btn }:any) => {
            const menu = menuFactory(btn.cellInfo.record.data);
            menu.alignTo({ target: btn })
            menu.show();
          }
        }]
      },
    ],
    listeners:{
      async add(event:any){
        if(event.records.length === 1 && event.isMove[event.records[0].id]){
          await systemStore.saveUserColumnOrder(TableType[TableType.plant], event.records[0].id, event.index.toString());
        }
      },
    }
  },
  store: gridStore,
  listeners: {
    selectionChange(event:any) {
      if(event.selection.length > 0 && event.selection[0]?.data === undefined) return;
      selectedPlants.value = selectedPlants.value.concat(event.selected.map(f=> f.data))
      selectedPlants.value = selectedPlants.value.filter(f => !event.deselected.map(fd => fd.data).some(fd => fd?.id === f?.id));
    },
    datachange(){
      systemStore.currentItems = gridStore.count;
      systemStore.allItems = gridStore.getCount();
    },
    async cellClick({column, record}:any) {
      if(column.data.field === 'infoButton'){
        systemStore.openPopup({
          data:record.data,
          action: () => {},
          resetButton:false,
          title:t("plantManagment.popups.plantDetails.title"),
          type:PopupType.plantDetailsPopup,
          big:true
        });
      }
    }
  },
  height: currentWindowHeight,
}
const gridConfig = reactive(useGridConfig)

const menuFactory = (record:object) => {
  const menu = new Menu({
    anchor   : true,
    autoShow : true,
    items	: [
      {
        text: t('global.edit'),
        cls: 'color',
        icon: 'icon-editieren',
        weight: 100,
        onItem : ({menu}:any) => {
          systemStore.openPopup({
            data: menu.record,
            action: addOrUpdatePlant,
            resetButton:false,
            title:t("plantManagment.popups.addOrUpdate.title.edit"),
            type:PopupType.addOrUpdatePlantPopup
          });
        }
      },
      {
        text: t("global.delete"),
        cls: 'color',
        icon: 'icon-loeschen',
        weight: 100,
        onItem : async ({menu}:any) => {
          const answer = await dialog
              .okText(t("global.delete"))
              .cancelText(t("global.cancel"))
              .confirm(t("plantManagment.confirmDeletionSingle", {name: menu.record.name}));

          if (answer) {
            const resp = await plantService.deletePlant(menu.record.id, ErrorLocationType.table)
            if(resp !== "")return

            gridStore.applyChangeset({removed:[{id:menu.record.id}]});
            systemStore.showSuccess(t('global.deleted'));
          }
        }
      },
    ],
  });

  menu.setRecord(record);

  return menu;
};

const addOrUpdatePlant = async () => {
  const plant = systemStore.modal.contentObject as Plant;

  plant.applicationRadius = typeof plant.applicationRadius === "string"
      ? +(plant.applicationRadius as string).replace(",",".")
      : plant.applicationRadius;

  const createResp = await plantService.addOrUpdatePlant(plant, ErrorLocationType.popup);
  if(!createResp) return;


  if(plant.id === '' || plant.id === undefined) plant.id = createResp.id;

  // in case of an update bryntum automatically replaces the entry with the same ID
  gridStore.add(plant);
  // reapply sorting
  await gridStore.sort(gridStore.sorters);
  // reapply filtering
  await gridStore.filter({
    id: "userFilter",
    filterBy: FilterService.buildFilter(TableType[TableType.user])
  });

  systemStore.closeModal();
  systemStore.showSuccess('Gespeichert');
}

const newPlant = async ()=>{
  systemStore.openPopup({
    data:new Plant(),
    action: addOrUpdatePlant,
    resetButton:false,
    title:t("plantManagment.popups.addOrUpdate.title.add"),
    type:PopupType.addOrUpdatePlantPopup
  });
}

const deleteSelection = async ()=>{
  //drop call without selection
  if(!selectedPlants.value?.some(()=>true)) return;

  const answer = await dialog
      .okText(t("global.delete"))
      .cancelText(t("global.cancel"))
      .confirm(t("plantManagment.confirmDeletionMulti", { count:selectedPlants.value.length}));

  if (answer) {
    let someEntriesFailed = false;
    for (const p of selectedPlants.value){
      const resp = await plantService.deletePlant(p.id, ErrorLocationType.table);
      if(resp !== ""){
        someEntriesFailed = true;
        continue;
      }

      gridStore.applyChangeset({removed:[{id:p.id}]});
    }

    if (someEntriesFailed) return;

    systemStore.showSuccess(t("global.deleted"));
  }
}

const openCsvImport = ()=>{
  systemStore.openPopup({
    data:{},
    action: async () => {
      const file = systemStore.uploadedFile;
      if(!file) return;

      const resp = await plantService.postPlantCsvImport(file as File, ErrorLocationType.popup)
      if(!resp) return

      // reset tmp-file-holder for space purposes
      systemStore.uploadedFile = null;

      // update globalStore data and filters etc
      await setGridData()

      systemStore.closeModal()
      systemStore.showSuccess(t('global.saved'))
    },
    resetButton:false,
    title:t("plantManagment.popups.importPlants.title"),
    type:PopupType.importPlantsPopup
  });
}

const exportCsv = ()=>{
  const rawData = selectedPlants.value?.length > 0 ? selectedPlants.value : gridStore.records;

  // remove unnecessary properties from csv
  const csvData = rawData.map((item)=> new PlantCsvExport(item.data ?? item));

  const fileName = t('plantManagment.exportFilename');
  const exportType =  exportFromJSON.types.csv;

  exportFromJSON({
    data:csvData,
    fileName:fileName,
    exportType:exportType,
  });
};

const setGridData = async () => {
  // start spinner
  systemStore.gridDataIsLoading = true;

  const plantData = await plantService.getPlants(ErrorLocationType.table);
  if (!plantData) return;

  gridStore.setStoreData(plantData);

  // apply filters
  await gridStore.filter({
    id: "userFilter",
    filterBy: FilterService.buildFilter(TableType[TableType.plant])
  });

  // apply hidden cols
  for(const c of grid.value.instance.value.columns.storage.values){
    const needsHiding = systemStore.userPreferences.userHiddenColumns
        .some((thc) => thc.attributeName === c.data.field && thc.tableName === TableType[TableType.plant]);

    if(needsHiding && !c.hidden) {
      c.hide();
    }
    else if(!needsHiding && c.hidden && !featureColumn.includes(c.id)) {
      c.show();
    }
  }

  systemStore.reorderColumns(TableType[TableType.plant]);

  // stop spinner
  systemStore.gridDataIsLoading = false;
}

onMounted(async ()=>{
  // calculate grid height and sub to window resize event
  recalcGridHeight();
  window.addEventListener('resize', recalcGridHeight);

  systemStore.setGridStore(ref(gridStore));
  systemStore.setGridColumnStore(ref(grid.value?.instance.value?.columns));

  // start spinner
  systemStore.gridDataIsLoading = true;
  await setGridData();
  // stop spinner
  systemStore.gridDataIsLoading = false;
})

onBeforeUnmount(async ()=>{
  window.removeEventListener('resize', recalcGridHeight);

  systemStore.setGridStore(null);
  systemStore.setGridColumnStore(null);

  systemStore.currentItems = 0;
  systemStore.allItems = 0;
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h4", null, _toDisplayString(_ctx.$t("plantManagment.title")), 1)
    ]),
    _createElementVNode("div", _hoisted_2, [
      _withDirectives(_createElementVNode("div", null, [
        _createVNode(Error, {
          errorLoc: _unref(ErrorLocationType).table
        }, null, 8, ["errorLoc"]),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("button", {
              class: "primary mr-2",
              onClick: newPlant,
              title: _unref(t)('plantManagment.new'),
              id: "createNew"
            }, _hoisted_7, 8, _hoisted_5),
            _createElementVNode("button", {
              class: "primary mr-2",
              onClick: deleteSelection,
              title: _unref(t)('global.delete'),
              disabled: !selectedPlants.value.some(()=>true),
              id: "deleteSelection"
            }, _hoisted_10, 8, _hoisted_8),
            _createElementVNode("button", {
              class: "primary mr-2",
              onClick: openCsvImport,
              title: _unref(t)('global.importCsv'),
              id: "openCsvImport"
            }, _hoisted_13, 8, _hoisted_11),
            _createElementVNode("button", {
              class: "primary mr-2",
              onClick: exportCsv,
              title: _unref(t)('global.exportCsv'),
              disabled: !selectedPlants.value.some(()=>true),
              id: "exportCsv"
            }, _hoisted_16, 8, _hoisted_14),
            _createElementVNode("div", _hoisted_17, [
              _createVNode(GridInputFilter, {
                gridStore: _unref(gridStore),
                hideFilterButton: true
              }, null, 8, ["gridStore"])
            ])
          ]),
          _createVNode(_unref(BryntumGrid), _mergeProps({
            ref_key: "grid",
            ref: grid
          }, gridConfig, { readOnly: true }), null, 16)
        ])
      ], 512), [
        [_vShow, !_unref(systemStore).gridDataIsLoading]
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_18, [
        _createVNode(LoadingSpinner)
      ], 512), [
        [_vShow, _unref(systemStore).gridDataIsLoading]
      ])
    ])
  ], 64))
}
}

})